module.exports = __webpack_public_path__ + "img/anniversary.eccb3a13.svg";